import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";



const EditActionTaken = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const { data } = location.state || {};
  console.log(data, "actionTakenData");
  const [editActionTaken, setEditActionTaken] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }

  useEffect(() => {
    fetchActionTakenEdit();
  }, []);

  const navigate = useNavigate();

  const fetchActionTakenEdit = async () => {
    try {
      const response = await axiosInstance.get(`/actiontaken/edit/${data.action_taken_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response.data.data; 
      const formatedData = {
        action_taken_name: fetchedData.action_taken_name,
        action_taken_desc: fetchedData.action_taken_desc,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id:fetchedData.business_partner_id,
      }
      setFormData(formatedData)
      setEditActionTaken(fetchedData);
      console.log("fetchedData", fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    ActionTakenInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, cancel!",
    });
    if (!result.isConfirmed) {
     // setLoading(false); 
      Swal.fire({
        title: "Cancelled",
        text: "The action has been cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
  
      return; 
    }
  
    try {
      setLoading(true); 
      const payload = {
        action_taken_name: formData.action_taken_name,
        action_taken_desc: formData.action_taken_desc,
        status: formData.status === "Active" ? 1 : 0,
      };
  
      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }
  
      setIsFormSubmitted(true); 
      const response = await axiosInstance.patch(`/actiontaken/update/${data.action_taken_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        Swal.fire({
          title: "Success",
          text: "Action taken updated successfully!",
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          navigate(ROUTES_NAVIGATION.ACTIONTAKENLIST); 
        });
      }
    } catch (error) {
      console.error("Error updating action taken:", error);
      const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
      Swal.fire({
        title: "Something went wrong",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false); 
    }
  };
  
  const ActionTakenInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
           
          },
        ]
      : []),
    {
      name: "action_taken_name",
      label: "Name",
      type: "text",
      required: true,
     validation: {
            required: true,
            pattern: /^[A-Za-z0-9-\s]*$/,
        message: "Special symbols are not allowed",
          },
      gridClass: "col-lg-4",
    },
    {
      name: "action_taken_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    
  ];

  return (
    <>
     {loading ? (
        <Loader />
      ) : (
        <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={() => navigate(ROUTES_NAVIGATION.ACTIONTAKENLIST)} />
        <span className="backbtntitle">Edit Action Taken</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Edit the Action Taken Details
        </span>
        <DynamicForm
          formConfig={ActionTakenInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
      )}
    </>
  );
};

export default EditActionTaken;
